import { lazy } from "react";
import { RouteObject } from "react-router-dom";

const HomePage = lazy(() => import("../pages/home/page"));
const MasterclassPage = lazy(() => import("../pages/masterclass/page"));
const ImpressumPage = lazy(() => import("../pages/impressum/page"));
const DatenschutzPage = lazy(() => import("../pages/datenschutz/page"));
const NotFound = lazy(() => import("../pages/NotFound"));

const routes: RouteObject[] = [
  {
    path: "/",
    element: <HomePage />,
  },
  {
    path: "/masterclass",
    element: <MasterclassPage />,
  },
  {
    path: "/seminar",
    element: <MasterclassPage />,
  },
  {
    path: "/impressum",
    element: <ImpressumPage />,
  },
  {
    path: "/datenschutz",
    element: <DatenschutzPage />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;
